import { IPageFilter } from "../../store/queries/page-filter.interface";
import { ContactFilters } from "./contact.reducer";
import { Contact } from "./contact.model";
import { itemSelector, listSelector, Qry } from "../query-facade";
import { VasState } from "../../store/store-type";
import { createSelector } from "reselect";
import { getFilterByPropertyFn, getFilterBySearchTermFn } from "../../../core/util/search-and-sort";
import { getSortByFn } from "../../../core/util/utils";

export class ContactPageFilter implements IPageFilter<Contact, ContactFilters> {

    constructor(protected qry: Qry) {

    }

    createSelector(itemsSelector: listSelector<Contact>, filterSelector: itemSelector<ContactFilters>): (state: VasState) => Array<Contact> {
        return createSelector(
            itemsSelector,
            filterSelector,
            this.qry.contactType.entities,
            (contacts, filters, contactTypeEntities) => {
                return contacts
                    .filter(getFilterBySearchTermFn(filters.searchTerm))
                    .filter(getFilterByPropertyFn("contactType", filters.contactType))
                    // sort
                    .sort(getSortByFn(filters.sortBy, filters.sortDirection, (sortBy: string, contact: Contact) => {
                        switch (sortBy) {
                            case "name":
                                return contact.name;
                            case "contactType":
                                return contactTypeEntities[contact.contactType].title;
                            default:
                                return 1;
                        }
                    }));
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact/contact.page-filter.ts